import styled from 'styled-components'

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
`

export const TimelineItem = styled.div`
  display: flex;
  gap: 8px;
`

export const TimelineSeparator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
`

export const TimelineConnector = styled.div<{ isLast: boolean }>`
  width: 1.3px;
  height: 12px;
  background-color: #e5e7eb;
  display: ${({ isLast }) => (isLast ? 'none' : 'block')};
  flex: 1;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    height: 12px;
    background-color: inherit;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    height: 12px;
  }
`

export const TimelineContent = styled.div`
  flex: 1;
  display: flex;
  align-items: start;
  padding: 2px 0;
`
